















































import Vue from 'vue'
import { mapGetters } from 'vuex'

import DateRangePicker from '../../components/DateRangePicker.vue'

/* eslint-disable */ 
import { Order } from '@/models/Order'
/* eslint-enable */


export default Vue.extend({

  data() {
    return {
      headers: [
        {
          text: 'Advisor',
          align: 'start',
          value: 'name',
        },
        { text: 'Total', value: 'total' },
      ],
      loading: false,
      dealerOrders: [] as Order[]
    }
  },
  computed: {
    ...mapGetters({
      currentDealerId: 'dealers/currentDealerId'
    }),
    advisors() : { id: number, name: string, total: number }[] {
      const advisors : { id: number, name: string, total: number }[] = []

      this.dealerOrders.forEach((order: Order) => {
        if (order.sellerId != null) {
          const name = order.seller.firstName + ' ' + order.seller.lastName
        
          const a = advisors.find((advisor: { id: number, name: string, total: number }) => advisor.id == order.sellerId)

          if (a === undefined) {
            advisors.push({ id: order.sellerId, name: name,  total: order.subtotal })
          } else {
            a.total = a.total + order.subtotal
          }
        }
      })

      return advisors
    },
    salesTotal() : number {
      let sum = 0
      this.dealerOrders.forEach((order: Order) => {
        if (order.sellerId != null) {
          sum = sum + order.subtotal
        }
      })

      return sum
    }
  },
  methods: {
    async requestOrders([start, end] : string[]) {
      this.loading = true
      this.dealerOrders = await Order.getOrders(null, this.currentDealerId, start, end)
      this.loading = false
    }
  },
  components: {
    DateRangePicker
  }
})
